module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0180.jpg?v=4e5e3ec3";